(() => {
  if (window.GFBrowsingPreferencesReady) return;
  window.GFBrowsingPreferencesReady = true;
  const states = new WeakMap();
  let privacyPromise;

  function privacyAPI() {
    const ready = () => typeof window.Shopify?.customerPrivacy?.currentVisitorConsent === 'function' && typeof window.Shopify?.customerPrivacy?.setTrackingConsent === 'function';
    if (ready()) return Promise.resolve(window.Shopify.customerPrivacy);
    if (privacyPromise) return privacyPromise;
    privacyPromise = new Promise((resolve, reject) => {
      if (typeof window.Shopify?.loadFeatures !== 'function') {reject(new Error('unavailable'));return;}
      const timeout = setTimeout(() => reject(new Error('unavailable')), 8000);
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], error => {
        clearTimeout(timeout);
        if (error || !ready()) reject(new Error('unavailable'));
        else resolve(window.Shopify.customerPrivacy);
      });
    }).catch(error => {privacyPromise = null;throw error;});
    return privacyPromise;
  }

  function close(state) {
    if (state.saving) return;
    state.version += 1;
    state.dialog.close();
  }

  function stateFor(root) {
    if (states.has(root)) return states.get(root);
    const state = {root, dialog: root.querySelector('[data-gf-privacy-dialog]'), input: root.querySelector('[data-gf-privacy-input]'), status: root.querySelector('[data-gf-privacy-status]'), save: root.querySelector('[data-gf-privacy-save]'), trigger: root.querySelector('[data-gf-privacy-open]'), version: 0, saving: false};
    state.dialog.addEventListener('cancel', event => {event.preventDefault();close(state);});
    state.dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = state.previousOverflow;
      state.trigger.focus({preventScroll: true});
    });
    state.dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const controls = [...state.dialog.querySelectorAll('button:not([disabled]),input:not([disabled]),a[href]')].filter(element => element.getClientRects().length);
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) {event.preventDefault();last?.focus();}
      else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first?.focus();}
    });
    state.dialog.addEventListener('click', event => {
      if (event.target !== state.dialog) return;
      const r = state.dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(state);
    });
    states.set(root, state);
    return state;
  }

  async function open(state) {
    if (state.dialog.open) return;
    const version = ++state.version;
    state.previousOverflow = document.documentElement.style.overflow;
    state.input.disabled = true;
    state.save.disabled = true;
    state.status.textContent = state.status.dataset.loading;
    state.previousChoice = null;
    state.dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    state.dialog.querySelector('[data-gf-privacy-close]').focus({preventScroll: true});
    try {
      const api = await privacyAPI();
      if (!state.dialog.open || version !== state.version) return;
      const consent = api.currentVisitorConsent().preferences;
      state.previousChoice = consent;
      state.input.checked = consent === 'yes' || (consent !== 'no' && api.preferencesProcessingAllowed() === true);
      state.input.disabled = false;
      state.save.disabled = false;
      state.status.textContent = '';
    } catch {
      if (state.dialog.open && version === state.version) state.status.textContent = state.status.dataset.error;
    }
  }

  async function save(state) {
    if (state.save.disabled || state.saving) return;
    state.saving = true;
    state.save.disabled = true;
    state.input.disabled = true;
    state.dialog.setAttribute('aria-busy', 'true');
    state.root.querySelectorAll('[data-gf-privacy-close]').forEach(button => {button.disabled = true;});
    state.status.textContent = state.status.dataset.saving;
    try {
      const api = await privacyAPI();
      const selected = state.input.checked;
      await new Promise((resolve, reject) => {
        const timeout = setTimeout(() => reject(new Error('unconfirmed')), 8000);
        api.setTrackingConsent({preferences: selected}, result => {
          clearTimeout(timeout);
          if (result?.error) {reject(new Error('unconfirmed'));return;}
          if (api.currentVisitorConsent().preferences !== (selected ? 'yes' : 'no')) {reject(new Error('unconfirmed'));return;}
          resolve();
        });
      });
      state.saving = false;
      close(state);
      state.root.querySelector('[data-gf-privacy-saved]').textContent = state.status.dataset.saved;
    } catch {
      state.status.textContent = state.status.dataset.error;
    } finally {
      state.saving = false;
      state.save.disabled = false;
      state.input.disabled = false;
      state.dialog.removeAttribute('aria-busy');
      state.root.querySelectorAll('[data-gf-privacy-close]').forEach(button => {button.disabled = false;});
    }
  }

  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-gf-privacy-open],[data-gf-privacy-close],[data-gf-privacy-save]');
    const root = button?.closest('[data-gf-privacy]');
    if (!root) return;
    const state = stateFor(root);
    if (button.hasAttribute('data-gf-privacy-open')) open(state);
    else if (button.hasAttribute('data-gf-privacy-close')) close(state);
    else save(state);
  });
})();
